import { useState } from 'react';

import { BenefitTag } from '@/components/productDetails/BenefitTag/BenefitTag';

export type BenefitTagsContainerType = {
  tags: Array<any>;
};

export const BenefitTagsContainer: React.FC<BenefitTagsContainerType> = ({
  tags,
}) => {
  const [more, showMore] = useState(false);
  const overflow =
    more || tags?.length <= 4
      ? ''
      : 'max-h-[64px] lg:max-h-full overflow-y-hidden';
  const text = more ? 'less' : 'more';
  const boxShadow = more ? '' : ' 0px -20px 10px 0px #ffffff inset';

  return (
    <div className="relative">
      <div className={`flex flex-wrap ${overflow}`}>
        {tags &&
          tags
            .filter((tag: any) => tag?.icon?.url)
            .map((tag: any, index: number) => (
              <div key={index}>
                <BenefitTag tag={tag} />
              </div>
            ))}
      </div>

      {tags?.length > 4 && (
        <>
          <div
            className="-mt-8 flex h-10 blur-sm lg:hidden"
            style={{ boxShadow }}
          ></div>
          <span
            className="flex pt-2 font-interMedium text-sm underline lg:hidden"
            onClick={() => showMore(!more)}
          >
            View {text}
          </span>
        </>
      )}
    </div>
  );
};
